/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Streak_PillInputs */

const en_us2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consistency`)
};

const pt_br2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constância`)
};

const es_419_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constancia`)
};

const pt_pt2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constância`)
};

const fr_fr2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régularité`)
};

const de_de2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beständigkeit`)
};

const it_it2_wrapped_streak_pill = /** @type {(inputs: Wrapped_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costanza`)
};

/**
* | output |
* | --- |
* | "Consistency" |
*
* @param {Wrapped_Streak_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_streak_pill = /** @type {((inputs?: Wrapped_Streak_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Streak_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_streak_pill(inputs)
	if (locale === "es-419") return es_419_wrapped_streak_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_streak_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_streak_pill(inputs)
	if (locale === "de-DE") return de_de2_wrapped_streak_pill(inputs)
	if (locale === "it-IT") return it_it2_wrapped_streak_pill(inputs)
	return en_us2_wrapped_streak_pill(inputs)
});
export { wrapped_streak_pill as "wrapped.streak_pill" }